import type { Movie } from "@/types/movie";

export interface FilterState {
  region: string;
  year: string;
  rating: string;
  sort: string;
}

export const defaultFilters: FilterState = {
  region: "all",
  year: "all",
  rating: "all",
  sort: "updated",
};

export const filterGroups = [
  {
    key: "region",
    label: "地区",
    options: [
      { label: "全部", value: "all" },
      { label: "韩国", value: "韩国" },
      { label: "日本", value: "日本" },
    ],
  },
  {
    key: "year",
    label: "年份",
    options: [
      { label: "全部", value: "all" },
      { label: "2021-2026", value: "2021-2026" },
      { label: "2016-2020", value: "2016-2020" },
      { label: "2011-2015", value: "2011-2015" },
      { label: "2010 以前", value: "before-2010" },
    ],
  },
  {
    key: "rating",
    label: "评分",
    options: [
      { label: "全部", value: "all" },
      { label: "9 分以上", value: "9" },
      { label: "8.5 分以上", value: "8.5" },
      { label: "8 分以上", value: "8" },
    ],
  },
  {
    key: "sort",
    label: "排序",
    options: [
      { label: "更新时间", value: "updated" },
      { label: "评分最高", value: "rating" },
      { label: "最多人看", value: "popularity" },
      { label: "名称", value: "title" },
    ],
  },
];

function matchYear(year: number, range: string): boolean {
  if (range === "all") return true;
  if (range === "2021-2026") return year >= 2021;
  if (range === "2016-2020") return year >= 2016 && year <= 2020;
  if (range === "2011-2015") return year >= 2011 && year <= 2015;
  if (range === "before-2010") return year <= 2010;
  return true;
}

function matchRating(rating: number, value: string): boolean {
  if (value === "all") return true;
  return rating >= Number(value);
}

export function filterMovies(
  list: Movie[],
  filters: FilterState,
  type?: Movie["type"],
): Movie[] {
  const result = list.filter(
    (movie) =>
      (!type || movie.type === type) &&
      (filters.region === "all" || movie.region === filters.region) &&
      matchYear(movie.year, filters.year) &&
      matchRating(movie.rating, filters.rating),
  );

  const sorted = [...result];
  if (filters.sort === "rating") sorted.sort((a, b) => b.rating - a.rating);
  else if (filters.sort === "popularity")
    sorted.sort((a, b) => b.popularity - a.popularity);
  else if (filters.sort === "title")
    sorted.sort((a, b) => a.title.localeCompare(b.title, "zh-Hans-CN"));
  else sorted.sort((a, b) => b.year - a.year || b.popularity - a.popularity);

  return sorted;
}